import styled from 'styled-components';

export const VerticalTabsStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  .vertical-tab-item {
    cursor: pointer;
    padding: 8px;
    background-color: white;
    border-radius: 8px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: var(--p-font-weight-medium);
    color: var(--p-color-text-brand);
    .vertical-tab-item-label {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    &.selected {
      background-color: var(--p-color-bg-fill-transparent-selected);
    }
  }
`;
